import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/useAuth";

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const { user, loading, token } = useAuth();
  const location = useLocation();

  // Still hydrating from localStorage — show nothing (avoids flash)
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-7 h-7 border-2 border-[#00C896]/30 border-t-[#00C896] rounded-full animate-spin" />
      </div>
    );
  }

  // No token → redirect to login
  if (!token || !user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Wrong role → unauthorized
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Admin account deactivated
  if (user.isActive === false) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center text-center px-6">
        <div>
          <div className="w-16 h-16 bg-red-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <i className="ri-user-unfollow-line text-red-400 text-3xl" />
          </div>
          <p className="text-white font-bold text-lg mb-2">Account Deactivated</p>
          <p className="text-white/40 text-sm max-w-xs mx-auto">
            Your admin account has been deactivated. Contact your super admin.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
